/**
 * The step a mask takes by itself once a new document has a number: from
 * `/purchase-orders/new` to `/purchase-orders/154533`, or from
 * `/customers/new/overview` to `/customers/11916`.
 *
 * It is not a way out of the mask, it is the mask arriving — and the document
 * was just written, so there is nothing to lose. Asking here stopped the mask
 * on the address it had left, with the number already assigned (#2210, R-04),
 * and on the masks that carry tabs it also ran the save-on-leave handler, which
 * pushed the form's pre-save values back over the saved ones: the mask then
 * reported unsaved input on a record that had just been written (#2212, R-29).
 */
export const isCreationStep = (from: string, to: string): boolean => {
    const fromSegments = from.split('/');
    const newSegment = fromSegments.indexOf('new');

    if (newSegment < 0) {
        return false;
    }

    const toSegments = to.split('/');

    // Same mask, and `new` has become a number — the tab behind it may stay,
    // go or change, which is the mask's own business.
    return (
        /^\d+$/.test(toSegments[newSegment] ?? '') &&
        fromSegments.slice(0, newSegment).join('/') === toSegments.slice(0, newSegment).join('/')
    );
};
